module.exports = __webpack_public_path__ + "img/08.3e3906d5.png";